import { useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Sidebar } from './Sidebar';

export function AdminLayout() {
  const { id: barId } = useParams();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[var(--color-bg)]">
      {/* Mobile header with hamburger */}
      <div className="lg:hidden fixed top-0 left-0 right-0 h-14 z-40 bg-[var(--color-card)] border-b border-[var(--color-border)] flex items-center px-4">
        <button
          onClick={() => setSidebarOpen(true)}
          className="p-2 -ml-2 rounded-lg hover:bg-[var(--color-border)]"
        >
          <Menu className="h-5 w-5" />
        </button>
        <span className="ml-2 text-lg font-bold text-accent-primary">Bar Guide Admin</span>
      </div>

      {/* Overlay when sidebar open on mobile */}
      {sidebarOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/50 z-40"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <Sidebar
        barId={barId}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main content - padding top on mobile for header, margin left on desktop for sidebar */}
      <main className="min-h-screen lg:ml-64 pt-[72px] px-4 pb-4 lg:pt-6 lg:px-6 lg:pb-6">
        <Outlet />
      </main>
    </div>
  );
}
